
<div class="modal fade" id="plans-modal" role="dialog" tabindex="-1" aria-labelledby="plans-modal" aria-hidden="true" [ngStyle]="{'display': (modalType != '') ? 'block' : 'none', 'opacity': 1,'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
  <div class="modal-dialog modal-dialog-centered modal-md" role="document">
    <div class="modal-content h-90">
      <div class="modal-header" >
        @if (!universalService?.isMobileDevice) {
          <button type="button" tabindex="-1" class="close btn-pos" data-dismiss="modal" (click)="closePopUp()">
            <span class="NeueFile_Cancel"></span>
            <span class="esc">esc</span>
          </button>
        }
        <h5 class="mb-0">Buy Storage</h5>
        @if (universalService?.isMobileDevice) {
          <span class="NeueFile_Cancel mt-1 mr-1" (click)="closePopUp()"></span>
        }
      </div>

      <div class="modal-body border-bottom-0" [ngClass]="[ universalService.isMobileDevice ? 'p-0' : 'pt-5' ]">
        <div class="plans-confimration" [ngClass]="[ universalService.isMobileDevice ? 'pt-2' : '' ]">
          @if (modalType == 'JioSim') {
            <ul>
              <li>Current subscriptions are open for Jio SIM customers only. Please check this page later for updates in our policy.</li>
            </ul>
          }
          @if (modalType == 'plan-purchase') {
            <ul>
              <li>Your subscription details will update in sometime if you have made any changes</li>
              <li>Thank you</li>
            </ul>
          }
        </div>
      </div>
      <div class="modal-footer border-top-0">
        <div class="plans-btn-main">
          @if (modalType == 'JioSim') {
            <button (click)="getJioSim()" tabindex="-1">GET JIO SIM</button>
          }
          @if (modalType == 'plan-purchase') {
            <button (click)="closePopUp()">OK</button>
          }
        </div>
      </div>
    </div>
  </div>
</div>